// AI-ASSISTED: generated with claude-code on 2026-08-17, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { EnvironmentUrlsCard } from './EnvironmentUrlsCard';

const environmentUrlsCard = EntityCardBlueprint.make({
  name: 'environment-urls',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { EnvironmentUrlsCard } = await import('./EnvironmentUrlsCard');
      return <EnvironmentUrlsCard />;
    },
  },
});

export const environmentUrlsCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [environmentUrlsCard],
});
